/* eslint comma-dangle: ["error", "always-multiline"] */

import { equipmentPrettyType } from 'Utils/filters.js';

export default {
  paginationPageSizes: [100, 200, 500, 1000], // eslint-disable-line no-magic-numbers
  enableFiltering: true,
  showGridFooter: true,
  showColumnFooter: false,
  useExternalSorting: true,
  columnDefs: [{
    field: 'name',
    displayName: 'Name',
    enableHiding: false,
    cellTooltip: true,
    enableCellEdit: false,
    width: '*',
    sort: { direction: 'asc' },
    // Natural sort (to handle eg "Thing 10" > "Thing 2")
    sortingAlgorithm: (a, b) => a.localeCompare(b, undefined, { numeric: true }),
  },
  {
    field: 'equipmentType',
    displayName: 'Type',
    cellFilter: 'equipmentPrettyType',
    enableHiding: false,
    enableCellEdit: false,
    width: '*',
    filter: {
      // This lets us filter by raw AND pretty type vs enabling filterCellFiltered
      condition: (searchTerm, type) => {
        const exp = new RegExp(searchTerm, 'i');
        return exp.test(type) || exp.test(equipmentPrettyType(type));
      },
    },
    sortingAlgorithm: (a, b) => equipmentPrettyType(a).localeCompare(equipmentPrettyType(b)),
  }],
  enableRowSelection: false,
  enableSelectAll: true,
  selectionRowHeaderWidth: 35,
  enableSorting: true,
  enableFullRowSelection: true,
  enableGroupHeaderSelection: true,
  enableHorizontalScrollbar: 2,
  enableCellSelection: true,
  enableCellEditOnFocus: false,
  multiSelect: true,
};
